(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-support"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var ta = document.getElementById('ContactForm-message');
    if (!ta) return;
    var out = document.getElementById('cntChar');
    var update = function () {
      out.textContent = ta.value.length;
    };
    ta.addEventListener('input', update);
    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-clean"]) return;
  try {
    
  (function () {
    const burger = document.querySelector('.c-burger');
    const drawer = document.getElementById('c-drawer');
    const overlay = document.querySelector('.c-drawer__overlay');
    if (!burger || !drawer || !overlay) return;
    function ensureOnBody() {
      if (!drawer.__ported) { document.body.appendChild(drawer); document.body.appendChild(overlay); drawer.__ported = true; }
    }
    function open() {
      ensureOnBody(); drawer.hidden = false; overlay.hidden = false; drawer.removeAttribute('aria-hidden');
      requestAnimationFrame(() => { overlay.style.opacity = '1'; overlay.style.pointerEvents = 'auto'; drawer.style.transform = 'translateX(0)'; });
      burger.setAttribute('aria-expanded', 'true'); document.documentElement.classList.add('c-drawer-open');
      bindDrilldown(); drawer.__resetToRoot?.();
    }
    function close() {
      overlay.style.opacity = '0'; overlay.style.pointerEvents = 'none'; drawer.style.transform = 'translateX(100%)';
      burger.setAttribute('aria-expanded', 'false');
      setTimeout(() => { drawer.hidden = true; overlay.hidden = true; drawer.setAttribute('aria-hidden', 'true'); drawer.__resetToRoot && drawer.__resetToRoot(); }, 200);
      document.documentElement.classList.remove('c-drawer-open');
    }
    overlay.addEventListener('click', close); burger.addEventListener('click', open);
    drawer.querySelector('.c-drawer__close')?.addEventListener('click', close);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !drawer.hidden) close(); });
    function bindDrilldown() {
      if (drawer.__drillBound) return; drawer.__drillBound = true;
      const root = drawer.querySelector('#mdrill-root'); const rootPanel = root?.querySelector('#mdrill-lv1');
      if (!root || !rootPanel) return;
      function setActive(panel) {
        const current = root.querySelector('.mdrill__panel--active');
        if (current && current !== panel) { current.classList.remove('mdrill__panel--active'); current.setAttribute('aria-hidden', 'true'); current.setAttribute('hidden', ''); }
        panel.classList.add('mdrill__panel--active'); panel.removeAttribute('hidden'); panel.removeAttribute('aria-hidden');
      }
      setActive(rootPanel); const stack = [];
      root.addEventListener('click', (e) => {
        const goBtn = e.target.closest('[data-target]'); const backBtn = e.target.closest('[data-back]');
        if (goBtn) { const sel = goBtn.getAttribute('data-target'); const next = root.querySelector(sel); if (!next) return; const current = root.querySelector('.mdrill__panel--active') || rootPanel; stack.push(current); setActive(next); }
        if (backBtn) { setActive(stack.pop() || rootPanel); }
      });
      drawer.__resetToRoot = () => { stack.length = 0; setActive(rootPanel); };
    }
  })();
  (function () {
    const trigger = document.querySelector('.c-icon--search'); const modal = document.getElementById('c-search-modal'); const overlay = document.querySelector('.c-search-modal__overlay');
    if (!trigger || !modal || !overlay) return;
    const input = modal.querySelector('.search__input'); const predictive = modal.querySelector('predictive-search'); const isPredictive = Boolean(predictive);
    const closeBtn = modal.querySelector('.c-search-modal__close'); let previousActive = null; let hideTimer = null;
    function ensureOnBody() { if (!modal.__ported) { document.body.appendChild(overlay); document.body.appendChild(modal); modal.__ported = true; } }
    function open() {
      ensureOnBody(); if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
      previousActive = document.activeElement; overlay.hidden = false; modal.hidden = false;
      requestAnimationFrame(() => { document.documentElement.classList.add('c-search-open'); trigger.setAttribute('aria-expanded', 'true'); if (isPredictive) { input?.setAttribute('aria-expanded', 'false'); } setTimeout(() => { input?.focus(); }, 180); });
    }
    function close() {
      document.documentElement.classList.remove('c-search-open'); trigger.setAttribute('aria-expanded', 'false');
      if (isPredictive) { input?.setAttribute('aria-expanded', 'false'); input?.removeAttribute('aria-activedescendant'); }
      hideTimer = setTimeout(() => { modal.hidden = true; overlay.hidden = true; hideTimer = null; }, 220);
      if (previousActive && typeof previousActive.focus === 'function') { previousActive.focus({ preventScroll: true }); }
    }
    trigger.addEventListener('click', open); overlay.addEventListener('click', close); closeBtn?.addEventListener('click', close);
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && document.documentElement.classList.contains('c-search-open')) { close(); } });
    modal.addEventListener('submit', () => { trigger.setAttribute('aria-expanded', 'false'); document.documentElement.classList.remove('c-search-open'); });
  })();

  } catch(e) { console.error(e); }
})();
})();
